export function formatPrice(price: string) {
  const numberFormat = Intl.NumberFormat("en", { notation: "compact" });
  try {
    return numberFormat.format(+price);
  } catch (e) {
    return price;
  }
}
